import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/banner.gif'
import _imports_1 from '@/assets/banner.mp4'


const _withScopeId = n => (_pushScopeId("data-v-73e2442f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Coming in January 2024")
], -1))
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  alt: "banner"
}
const _hoisted_3 = {
  key: 1,
  src: _imports_1,
  playsinline: "",
  autoplay: "",
  loop: "",
  muted: ""
}

import { ref } from 'vue';
import { detect } from 'detect-browser';


export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const browser = detect();
const isSafari = ref<boolean>(browser?.name === 'safari' || browser?.name === 'ios' || browser?.name === 'crios');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _hoisted_1,
    (isSafari.value)
      ? (_openBlock(), _createElementBlock("img", _hoisted_2))
      : (_openBlock(), _createElementBlock("video", _hoisted_3))
  ]))
}
}

})